import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => {
  return ({
    container: {
      height: 'auto',
      backgroundColor: '#fff',
      color: '#6F6F6F',
      minHeight: '57px',
      boxShadow: '0px -3px 6px #00000029',
    },
    logoImage: {
      height: '28px',
      margin: '0 0 0 40px',
    },
    anchorlink: {
      color: '#026AE3',
      textDecoration: 'none',
    },
    text: {
      fontFamily: 'Helvetica Neue',
      color: '#6F6F6F',
      fontSize: '14px',
    },
  })
})

export { useStyles }
